import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { GraduationCap, Briefcase, Globe, BookOpen } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageHead from "@/components/PageHead";

const ToolsSelectionPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const cards = document.querySelectorAll('.tool-card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.remove('opacity-0', 'translate-y-4');
        card.classList.add('opacity-100', 'translate-y-0');
      }, index * 100);
    });
  }, []);

  const toolOptions = [
    {
      id: "visa-jobs",
      title: "Visa Sponsored Jobs",
      description: "Find employment opportunities with visa sponsorship in your desired country.",
      icon: <Briefcase className="h-8 w-8" />,
      color: "bg-gradient-to-br from-blue-100 to-blue-200 text-blue-600 hover:shadow-blue-100",
      path: "/visa-sponsored-jobs"
    },
    {
      id: "travel-guides",
      title: "Visa Travel Guides",
      description: "Step-by-step guides for visa applications and travel requirements for various countries.",
      icon: <Globe className="h-8 w-8" />,
      color: "bg-gradient-to-br from-green-100 to-green-200 text-green-600 hover:shadow-green-100",
      path: "/visa-travel-guides"
    },
    {
      id: "scholarships",
      title: "Scholarship Opportunities",
      description: "Discover scholarships and funding options for international students.",
      icon: <GraduationCap className="h-8 w-8" />,
      color: "bg-gradient-to-br from-amber-100 to-amber-200 text-amber-600 hover:shadow-amber-100",
      path: "/scholarships"
    },
    {
      id: "blog",
      title: "Travel Blog",
      description: "Read expert insights and guides about living and working abroad.",
      icon: <BookOpen className="h-8 w-8" />,
      color: "bg-gradient-to-br from-purple-100 to-purple-200 text-purple-600 hover:shadow-purple-100",
      path: "/blog"
    },
  ];

  const handleSelection = (path: string) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <PageHead title="Tools" />
      <Navbar />
      
      <main className="flex-grow flex flex-col items-center justify-center py-16 px-4 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-4xl w-full">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">What would you like to explore today?</h1>
            <p className="text-lg text-gray-600">
              Select one of our tools to help you on your journey
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {toolOptions.map((tool) => (
              <div 
                key={tool.id}
                className={`tool-card opacity-0 translate-y-4 transition-all duration-500 ease-out cursor-pointer rounded-xl ${tool.color} p-6 hover:scale-105 transition-transform`}
                onClick={() => handleSelection(tool.path)}
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-white/80 backdrop-blur p-3 rounded-lg">
                    {tool.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold mb-2">{tool.title}</h3>
                    <p className="text-sm opacity-90">{tool.description}</p>
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <Button 
                    variant="ghost" 
                    className="text-current hover:bg-white/50"
                  >
                    Explore <span className="ml-2">→</span>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ToolsSelectionPage;
